import React from "react";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/footer/Footer";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ex6 from "../../assets/images/ex6.png";
import NorthEastOutlinedIcon from "@mui/icons-material/NorthEastOutlined";
import missionHome from "../../assets/images/mission-image.png";
import lineTop from "../../assets/images/line-top.png";
import lineBottom from "../../assets/images/line-bottom.png";
import founder1 from "../../assets/images/founder-image1.jpeg";
import founder2 from "../../assets/images/founder-image2.jpeg";
import founder3 from "../../assets/images/founder-image3.jpeg";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const About = () => {
  return (
    <div>
      <Navbar />
      <div className="page-header bg-[#F8F8F8] ">
        <div className="container">
          <h1 className="font-bold text-xl mb-3 text-[#003245]">
            About AGA Amin Grand Asia
          </h1>
          <ul className="flex gap-2">
            <Link to="/" className="text-sm text-[#003245]">
              Home
            </Link>
            <ChevronRightIcon sx={{ fontSize: "19px" }} />
            <Link to="/about-us" className="text-sm text-[#003245]">
              About Us
            </Link>
          </ul>
        </div>
      </div>

      <section className="pt-[5rem] pb-[6rem]">
        <div className="container">
          <div className="about-row">
            <div className="about-img">
              <img src={ex6} alt="About Us" />
            </div>

            <div className="about-content">
              <small className="small-text">
                <span></span> About AGA
              </small>
              <h1>We are the heavy machinery expert</h1>
              <p>
                Amin Grand Asia Construction Equipment and Machinery Trading LLC
                is a premier provider of heavy equipment solutions, specializing
                in mobile cranes, tower cranes, and more. We offer comprehensive
                services for trading, rental projects, and import/export,
                catering to the diverse needs of the construction industry. With
                offices in Dubai and Sharjah, we are committed to delivering
                high-quality, reliable equipment to support your projects across
                the UAE.
              </p>

              <p>
                With our extensive industry experience, we have built a
                reputation for being a trusted partner in the construction
                sector, providing tailored solutions that drive project success.
              </p>

              <div className="about-wrap-btns">
                <Link to="/contact-us" className="btn-home btn-learn-more">
                  Contact Us
                  <NorthEastOutlinedIcon
                    sx={{ fontSize: "20px", marginLeft: "8px" }}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="demographic-section relative">
        <img
          src={lineTop}
          alt="Background Lines"
          className="absolute top-0 left-0 h-full"
        />
        <div className="container">
          <div className="text-center sec-hdng">
            <div className="small-text justify-center">
              <span></span> Our Achivements
            </div>
            <h1>
              25 strong years of fulfilling the world's demand for heavy
              machinery.
            </h1>
          </div>

          <div className="demo-box-row">
            <div className="demo-box">
              <h1>25+</h1>
              <p>Years In Business</p>
            </div>
            <div className="demo-box">
              <h1>500+</h1>
              <p>Orders Fulfilled</p>
            </div>
            <div className="demo-box">
              <h1>90+</h1>
              <p>Operators</p>
            </div>
            <div className="demo-box">
              <h1>60+</h1>
              <p>Machinery In Stock</p>
            </div>
          </div>
        </div>
        <img
          src={lineBottom}
          alt="Background Lines"
          className="absolute top-0 right-0 h-full"
        />
      </section>

      <section className="pt-[5rem] pb-[6rem]">
        <div className="container">
          <div className="about-row">
            <div className="about-content">
              <small className="small-text">
                <span></span> Our Mission
              </small>
              <h1>Pioneering Digital Machinery Solutions</h1>
              <p>
                Our mission is to provide high-quality equipment solutions that
                empower construction and industrial projects to succeed. Whether
                you are looking to purchase or rent equipment, we offer flexible
                and reliable options designed to meet the unique requirements of
                your project.
              </p>

              <p>
                At Amin Grand Asia, we are committed to excellence in service
                and precision in equipment. We take pride in our ability to
                offer industry-leading machinery that delivers on both
                performance and safety. Our dedicated team ensures that every
                piece of equipment is well-maintained and ready to operate,
                giving you peace of mind for your most demanding projects.
              </p>
            </div>

            <div className="about-img mission-image">
              <img src={missionHome} alt="Our Mission" />
            </div>
          </div>
        </div>
      </section>

      <section className="pt-[0rem] pb-[6rem]">
        <div className="container">
          <div className="flex-hdng">
            <div>
              <div className="small-text">
                <span></span> Our Team
              </div>
              <h1 className="heading1">Our Founders - Amin Grand Asia</h1>
            </div>

            <div>
              <Link
                to="/organizational-chart"
                className="btn-home btn-outline-red"
              >
                Organizational Chart
                <NorthEastOutlinedIcon
                  sx={{ fontSize: "20px", marginLeft: "8px" }}
                />
              </Link>
            </div>
          </div>

          <div className="founders-wrap flex gap-5 justify-center mt-5">
            <div className="founder-card">
              <div className="fc-img">
                <img src={founder1} alt="Seyed Bagher" />
              </div>
              <div className="fc-content">
                <h3>Mr. Seyed Bagher</h3>
                <p>Founder & CEO</p>
                <a
                  href="https://wa.me/971501381984?text=Hi,%20I'd%20like%20to%20learn%20about%20new%20offers%20about%20heavy%20machinery."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsappIcon"
                >
                  <WhatsAppIcon />
                </a>
                <a
                  href="https://www.linkedin.com/in/crane-mousavi-91a2ba137?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkedinIcon"
                >
                  <LinkedInIcon />
                </a>
                <a
                  href="mailto:mousavi@agacrane.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="emailIcon"
                >
                  <MailOutlineIcon />
                </a>
              </div>
            </div>

            <div className="founder-card">
              <div className="fc-img">
                <img src={founder2} alt="Seyed Mahdi" />
              </div>
              <div className="fc-content">
                <h3>Mr. Seyed Mahdi</h3>
                <p>Co Founder & CEO</p>
                <a
                  href="https://wa.me/971501501145?text=Hi,%20I'd%20like%20to%20learn%20about%20new%20offers%20about%20heavy%20machinery."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsappIcon"
                >
                  <WhatsAppIcon />
                </a>
                <a
                  href="https://www.linkedin.com/in/crane-mousavi-91a2ba137?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkedinIcon"
                >
                  <LinkedInIcon />
                </a>
                <a
                  href="mailto:mehdi@agacrane.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="emailIcon"
                >
                  <MailOutlineIcon />
                </a>
              </div>
            </div>

            <div className="founder-card">
              <div className="fc-img">
                <img src={founder3} alt="Seyed Mahdi" />
              </div>
              <div className="fc-content">
                <h3>Mr. Seyed Sajjad Mousavi</h3>
                <p>Co Founder & CEO</p>
                <a
                  href="https://wa.me/971501501145?text=Hi,%20I'd%20like%20to%20learn%20about%20new%20offers%20about%20heavy%20machinery."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsappIcon"
                >
                  <WhatsAppIcon />
                </a>
                <a
                  href="https://www.linkedin.com/in/crane-mousavi-91a2ba137?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkedinIcon"
                >
                  <LinkedInIcon />
                </a>
                <a
                  href="mailto:info@agacrane.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="emailIcon"
                >
                  <MailOutlineIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default About;
